export default __webpack_public_path__ + "static/media/chillrx-stack4.webp";